import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';

const News = () => {
  const newsItems = [
    {
      id: 1,
      title: 'New UK Gambling Regulations Take Effect in 2026',
      excerpt: 'The UK Gambling Commission announces stricter affordability checks and enhanced player protection measures starting January 2026.',
      date: '2025-11-29',
      slug: 'new-uk-gambling-regulations-2026',
      image: '/images/aceofnet-gTp5dGK6jtY-unsplash.webp'
    },
    {
      id: 2,
      title: 'Top 5 Casino Bonuses for December 2025',
      excerpt: 'We\'ve analyzed hundreds of offers to bring you the most valuable bonuses this month. See which casinos are offering the best deals.',
      date: '2025-11-25',
      slug: 'top-5-casino-bonuses-december-2025',
      image: '/images/aidan-howe-xrR-Kr2zppo-unsplash.webp'
    },
    {
      id: 3,
      title: 'How to Spot a Trustworthy Online Casino',
      excerpt: 'Learn the key indicators of a reliable casino platform: license verification, payment security, and player protection measures.',
      date: '2025-11-20',
      slug: 'how-to-spot-trustworthy-online-casino',
      image: '/images/amit-lahav-HffApi3okak-unsplash.webp'
    }
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  return (
    <section id="news" className="py-20 bg-regal-dark">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">
            Latest Casino News
          </h2>
          <p className="text-xl text-gray-400">
            Stay informed about the UK casino industry, new bonuses, and player updates
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {newsItems.map((item, index) => (
            <article
              key={item.id}
              itemScope
              itemType="https://schema.org/NewsArticle"
              className={`bg-regal-gray rounded-xl overflow-hidden border border-gray-800 hover:border-regal-red transition-all ${
                index === 0 ? 'md:col-span-1' : ''
              }`}
            >
              <div className="h-48 relative overflow-hidden">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-full object-cover"
                  itemprop="image"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 text-gray-400 text-sm mb-3">
                  <Calendar size={16} />
                  <time dateTime={item.date} itemprop="datePublished">{formatDate(item.date)}</time>
                </div>
                <h3 className="text-xl font-bold text-white mb-3 leading-tight" itemprop="headline">
                  {item.title}
                </h3>
                <p className="text-gray-300 mb-4 leading-relaxed" itemprop="description">
                  {item.excerpt}
                </p>
                <Link
                  to={`/news/${item.slug}`}
                  data-discover="true"
                  className="inline-flex items-center gap-2 text-regal-red hover:text-red-400 font-semibold transition-colors"
                  itemprop="url"
                >
                  Read More
                  <ArrowRight size={16} />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;

